import React from 'react';
import { GenericFormPage } from '../../components/generic';
import { useOfferTemplate, OfferTemplate } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<OfferTemplate>
      useData={useOfferTemplate}
      config={{
        ...moduleConfig,
        getInitialFormData: getInitialFormData as () => Partial<OfferTemplate>,
        mapItemToFormData: mapItemToFormData as (item: OfferTemplate) => Partial<OfferTemplate>,
      }}
    />
  );
};

export default Form;
